<!--
 * @Author: ningbo.kang
 * @Date: 2020-06-02 17:43:31
 * @LastEditors: wenpan.cao@ecarxgroup.com
 * @LastEditTime: 2023-07-21 10:48:38
 * @Description: 描述
 -->
<template>
  <div widget-type="link">
    <ul class="ant-checkbox-group text-content">
      <li v-for="(item, index) in links"
        class="ant-checkbox-wrapper"
        :key="index">
        <template v-if="isRouterLink(item.value)">
          <router-link target="_blank"
            :to="{
              path: item.value,
              query: { title: item.label || item.value },
            }">{{ item.label || item.value }}</router-link>
        </template>
        <template v-else>
          <a target="_blank"
            :href="item.value">{{
            item.label || item.value
          }}</a>
        </template>
      </li>
    </ul>
  </div>
</template>
<script>
import baseMixin from '../../lib/baseMixin';

export default {
  mixins: [baseMixin],
  data() {
    return {
      options: {
        inline: true,
        defaultValue: '[]',
        showLabel: false,
        options: [],
        required: false,
        width: '100%',
        remote: false,
        remoteType: 'func',
        remoteOption: '',
        remoteOptions: [],
        props: {
          value: 'value',
          label: 'label',
        },
        remoteFunc: '',
        customClass: '',
        labelWidth: 100,
        isLabelWidth: false,
        hidden: false,
        dataBind: true,
        disabled: false,
      },
      linkList: [],
    };
  },
  mounted() {
    this.initOptions();
  },
  computed: {
    links() {
      if (this.text.length > 0) {
        return this.text.map(item => ({
          value: item.url || item.value,
          label: item.title || item.label,
        }));
      }
      return this.linkList;
    },
  },
  methods: {
    initVal(val) {
      let strVal = val;
      if (val === undefined || val === '' || val === null) {
        strVal = '[]';
      }
      try {
        this.text = JSON.parse(strVal);
      } catch (error) {
        this.text = [];
      }
    },
    initOptions() {
      this.linkList = this.options.options;
    },
    isRouterLink(url) {
      const routerLinkFlag = url && (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('//'));
      if (routerLinkFlag) {
        return false;
      }
      return true;
    },
  },
};
</script>
